import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import styles from "./Employee.module.css"
import classNames from "classnames";
import _ from 'lodash';
import {CRM_BASE_URL} from "../../app/crm";

const EmployeeItem = ({isActive, onClick, employee, headRight, body, className}) => {
    const classes = _.merge({[styles.EmployeeItem]: true, [styles.Active]: isActive}, className);

    return (
        <div className={classNames(classes)} id={'employee_' + employee.id} onClick={onClick}>
            <div className={styles.EmployeeItemHead}>
                <div className={styles.EmployeeItemHeadLeft}>
                    <div className={styles.EmployeeIcon}/>
                    <h5 className={styles.EmployeeName} onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(employee.name)
                        }}>
                        <span>{employee.name}{
                            typeof employee.cleaning_completed_orders_count !== "undefined"
                                ? ( <span className={styles.EmployeeCompletedOrdersCount} title="Количество выполненных заказов">({employee.cleaning_completed_orders_count})</span>)
                                : ''
                        }{
                            employee.is_test_performer
                                ? ( <span className="label label-primary" style={{"margin-left": "10px", "fontFamily": "sans-serif"}} title="Тестовый исполнитель">Т</span>)
                                : ''
                        }</span>
                        <a href={CRM_BASE_URL + '/logistics/courier/' + employee.id} target="_blank" rel="noreferrer" className={styles.EmployeeEditIcon}>
                            <FontAwesomeIcon icon={faPencilAlt}/>
                        </a>
                    </h5>
                    <span className={styles.EmployeePhone} onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(employee.phone)
                        }}>
                        {employee.phone}
                    </span>
                </div>
                <div className={styles.EmployeeItemHeadRight}>
                    {headRight}
                </div>
            </div>
            <div className="clearfix"/>
            <div>
                {body}
            </div>
        </div>
    );
}

export default EmployeeItem;